// Belarusian translations
export const be: Record<string, string> = {
  'menu.dashboard': 'Панэль кіравання',
  'menu.customers': 'Кліенты',
  'menu.products': 'Прадукты',
  'menu.users': 'Карыстальнікі',
  'menu.settings': 'Налады',
  'menu.logout': 'Выхад',
  'dashboard.title': 'Панэль кіравання',
  'dashboard.newOrder': 'Новы заказ',
  'order.title': 'Новы заказ',
  'order.customer': 'Кліент',
  'order.products': 'Прадукты',
  'order.total': 'Усяго',
  'users.title': 'Карыстальнікі',
  'users.name': 'Імя',
  'users.email': 'Электронная пошта',
  'common.yes': 'Так',
  'common.no': 'Не',
  'common.cancel': 'Адмяніць',
  'common.save': 'Захаваць',
  'common.search': 'Пошук',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Увайсці',
  'login.welcome': 'Вітаем, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Электронная пошта',
  'signup.phone': 'Тэлефон',
  'menu.reportsAndAccounting': 'Справаздачы і бухгалтэрыя',
  'menu.systemAndCommunication': 'Сістэма і сувязь',
};